import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
import Animated, {
  useSharedValue,
  useAnimatedProps,
  withTiming,
  Easing,
} from "react-native-reanimated"

const AnimatedPath = Animated.createAnimatedComponent(Path)

const SvgComponent = (props: SvgProps) => {
  const progress = useSharedValue(0)

  React.useEffect(() => {
    progress.value = withTiming(1, {
      duration: 600,
      easing: Easing.out(Easing.cubic),
    })
  }, [])

  const animatedProps = useAnimatedProps(() => {
    return {
      strokeDashoffset: 100 - 100 * progress.value,
    }
  })

  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 100 100"
      fill="none"
      {...props}
    >
      <AnimatedPath
        d="M20 55 L40 75 L80 30"
        stroke="#fff"
        strokeWidth={8}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray={100}
        animatedProps={animatedProps}
      />
    </Svg>
  )
}

export default SvgComponent